import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import PageMeta from '../components/PageMeta';
import api from '../config/api';
import './Contact.css';

const Contact = () => {
  const location = useLocation();
  const { t, language } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (location.state?.subject) {
      setFormData(prev => ({ ...prev, subject: location.state.subject }));
    }
  }, [location.state?.subject]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    setSubmitting(true);
    try {
      await api.post('/contact', formData);
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 5001);
    } catch (err) {
      setSubmitError(err.response?.data?.error || t('contact.errorSend'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <PageMeta
        title={t('seo.contact.title')}
        description={t('seo.contact.description')}
        path="/contact"
        locale={language}
      />
      <div className="container">
        <h1 className="page-title">{t('contact.title')}</h1>
        
        <div className="contact-content">
          <div className="contact-info">
            <h2>{t('contact.infoTitle')}</h2>
            
            <div className="info-item">
              <FaEnvelope className="info-icon" />
              <div>
                <h3>{t('contact.email')}</h3>
                <p>info@oltrefrontiera.ch</p>
              </div>
            </div>

            <div className="info-item">
              <FaPhone className="info-icon" />
              <div>
                <h3>{t('contact.phone')}</h3>
                <p>+41 78 628 96 88</p>
              </div>
            </div>

            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <h3>{t('contact.address')}</h3>
                <p dangerouslySetInnerHTML={{ __html: t('contact.addressLine') }} />
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>{t('contact.formTitle')}</h2>
            <p className="contact-form-note">{t('contact.formNote')}</p>

            {submitted && (
              <div className="success-message">
                {t('contact.success')}
              </div>
            )}

            {submitError && (
              <div className="error-message" role="alert">
                {submitError}
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">{t('contact.nameLabel')}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.namePlaceholder')}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">{t('contact.emailLabel')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.emailPlaceholder')}
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">{t('contact.subjectLabel')}</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.subjectPlaceholder')}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">{t('contact.messageLabel')}</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder={t('contact.messagePlaceholder')}
                />
              </div>

              <button type="submit" className="btn-submit" disabled={submitting}>
                {submitting ? t('contact.sending') : t('contact.submit')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

